import React from 'react';

const Image = (props) => {
    const { posItemId, style, alt, imageHash } = props;
    const imagePlaceholder =
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgNDAwIDMwMCI+CiAgPHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0iI2YzZjRmNiIvPgogIDxyZWN0IHg9IjEyIiB5PSIxMiIgd2lkdGg9IjM3NiIgaGVpZ2h0PSIyNzYiIHJ4PSIxNiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZDFkNWRiIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1kYXNoYXJyYXk9IjYgNiIvPgogIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIwMCwxMjApIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjOWNhM2FmIj4KICAgIDxyZWN0IHg9Ii04MCIgeT0iLTQ4IiB3aWR0aD0iMTYwIiBoZWlnaHQ9Ijk2IiByeD0iMTAiIGZpbGw9IiNmZmZmZmYiIHN0cm9rZT0iI2U1ZTdlYiIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8Y2lyY2xlIGN4PSItNDAiIGN5PSItOCIgcj0iMTIiIGZpbGw9IiNlNWU3ZWIiLz4KICAgIDxyZWN0IHg9Ii02IiB5PSItMTgiIHdpZHRoPSI4NCIgaGVpZ2h0PSI2MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZTVlN2ViIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0icm90YXRlKC0xMCkiLz4KICAgIDxwYXRoIGQ9Ik0tNzIgNTIgTDcyIC01MiIgc3Ryb2tlPSIjZDFkNWRiIiBzdHJva2Utd2lkdGg9IjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgPHRleHQgeD0iMCIgeT0iODAiIGZvbnQtZmFtaWx5PSJBcmlhbCwgSGVsdmV0aWNhLCBzYW5zLXNlcmlmIiBmb250LXNpemU9IjE4IiBmaWxsPSIjNmI3MjgwIj5ObyBpbWFnZTwvdGV4dD4KICA8L2c+Cjwvc3ZnPg==';

    return (
        <img
            src={
                posItemId && posItemId !== null && imageHash
                    ? '/getPosItemImage/' + posItemId + '?imageHash=' + imageHash
                    : imagePlaceholder
            }
            alt={alt ? alt : 'thumbnail'}
            style={style ? style : { height: '50px', width: '50px' }}
        />
    );
};

export default Image;
